import { Button } from "../../../../../components";

interface Props {
  handleClose?: () => void;
  title: string;
  handleCreateClick: () => void;
  emailIsValid: boolean;
}

export const OrganizationInfoDrawerHeader = ({
  handleClose,
  title,
  handleCreateClick,
  emailIsValid,
}: Props) => {
  return (
    <div className="flex flex-row justify-between items-center gap-4 px-4 sm:px-5 py-4 bg-gray-1 border-b border-gray-2 rounded-tl-2xl">
      <div className="flex flex-row sm:px-4 items-center justify-center gap-2">
        <p className="text-sm hidden sm:block">{title}</p>
      </div>
      <div>
        <Button variant="primary" onClick={handleClose}>
          Close
        </Button>
      </div>
    </div>
  );
};
